/* eslint-disable react/jsx-pascal-case */
import React, { useEffect } from "react";
import Cards from "../Cards";
import './index.scss';
import { useDispatch, useSelector } from 'react-redux'
import Course_1 from "../courseCards/course_1_cards";
import { Modal, Button } from 'antd';
import initialQuery, { queryNFT, viewNFT } from "../../services/contracts";
import { useState } from "react";
import logo from '../../assets/images/comdexCertificateLogo.svg'
import { toast } from "react-toastify";
import { mintNftTransaction } from "../../services/contractWrite";

const CourseModule = () => {

    const data = useSelector((state) => state.module.list);
    const [count, setCount] = useState(0);
    const [showMintBtn, setShowMintBtn] = useState(true)
    const [disableBtn, setDisableBtn] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [userNFTid, setUserNFTId] = useState("");
    const [progress, setProgress] = useState(false)
    const [userNFTData, setUserNFTData] = useState({
        address: "",
        modulename: "",
        date: ""
    })

    console.log(data);
    console.log(count);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const mint = () => {
        toast.info(
            <span className='toast'>Transaction Initiated</span>,
            {
                position: "bottom-center",
            }
        );

        // mintNftTransaction(currentModule, currentModuleName, (error, result) => {
        //     if (error) {
        //         console.log(error);
        //         setProgress(false)

        //         toast.error(
        //             <span className='toast'>Transaction Failed</span>,
        //             {
        //                 position: "bottom-center",
        //             }
        //         );
        //         return;
        //     }
        //     setProgress(false)



        //     toast.success(
        //         <span className='toast'>Transaction Successful</span>,
        //         {
        //             position: "bottom-center",
        //         }
        //     );
        //     if (result) {

        //         setShowMintBtn(false)
        //     }

        // });
    }


    useEffect(() => {
        // fetchCompletedModuleData()
        window.scrollTo(0, 0)
    }, [])

    const fetchCompletedModuleData = () => {
        let flag = 0;
        data.map((item, index) => {
            console.log(item.lessons.length);
            initialQuery(index + 1).then((res) => {
                console.log(res);
                if (res.length === item.lessons.length) {
                    flag++;
                    console.log("Completed");
                }
                console.log(flag);
                setCount(flag);
            })
        })
        if (count === data.length) {
            console.log("If count equal", count);
            // setShowMintBtn(false);
            setDisableBtn(false)

            // setProgress(false)
        }
    }


    return (
        <section>
            <div className="dashboard-main-container ">
                <div className="container">
                    <div className="dashboard-container">
                       
                    </div>
                </div>
            </div>
            <Cards />
        </section>
    )
}

export default CourseModule;